import styled from '@emotion/styled';
import { IMaskInput } from 'react-imask';
import { css } from '@mui/material';
import { colors } from 'theme/colors';

interface IStyledMaskedFormInput {
  error: boolean;
}

export const StyledMaskedFormInput = styled(IMaskInput)<IStyledMaskedFormInput>`
  border-width: 1px;
  border-style: solid;
  border-color: ${colors.gray400};
  border-radius: 4px;
  font-size: 14px;
  height: 1.4375em;
  width: 100%;
  padding: 15px 14px;
  margin-bottom: 3px;

  &:hover {
    border-color: ${colors.primary400};
  }

  &:focus {
    box-shadow: inset 0 0 0 2px ${colors.primary400};
    outline: none;
  }

  &:active {
    border-color: ${colors.primary900};
    border-width: 1px;
  }

  &::placeholder {
    font-size: 14px;
    font-weight: 400;
    color: ${colors.gray400};
    font-family: 'NotoSansRegular, sans-serif', sans-serif;
    opacity: 1;
  }

  ${(props: IStyledMaskedFormInput) =>
    props.error &&
    css`
      border-color: ${colors.error800};
      border-width: 1px;

      &:hover {
        border-color: ${colors.error800};
      }

      &:focus {
        border-color: ${colors.error800};
        border-width: 1px;
      }
    `}
`;
